// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_h9-7";
export var emphasizeQuantity = "_h9-3";
export var flatBottomCorners = "_h9-5";
export var productImage = "_h9-0";
export var quantityContainer = "_h9-2";
export var quantityHeader = "_h9-6";
export var tooltip = "_h9-1";
export var wrapAndEllipsesOverflow = "_h9-4";